document.addEventListener('DOMContentLoaded', function () {
  const armSwatches = document.querySelectorAll('.unified-arm-swatches .arm-picker');
  const leftInput = document.getElementById('arm-left-input');
  const rightInput = document.getElementById('arm-right-input');

  let currentStep = 'right';

  // Default selected swatch
  const defaultColor = 'blackblack';
  const defaultSwatch = Array.from(armSwatches).find(s => s.dataset.color === defaultColor);

  if (defaultSwatch) {
    // Set input values
    leftInput.value = defaultColor;
    rightInput.value = defaultColor;

    // Set both arm border colors
    defaultSwatch.style.setProperty('--left-arm-border-color', '#bbff45');
    defaultSwatch.style.setProperty('--right-arm-border-color', '#bbff45');
  }

  armSwatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      const color = swatch.getAttribute('data-color');

      if (!color) return;

      if (currentStep === 'right') {
        rightInput.value = color;

        armSwatches.forEach(s => s.style.setProperty('--right-arm-border-color', 'transparent'));
        swatch.style.setProperty('--right-arm-border-color', '#bbff45');

        currentStep = 'left';
      } else {
        leftInput.value = color;

        armSwatches.forEach(s => s.style.setProperty('--left-arm-border-color', 'transparent'));
        swatch.style.setProperty('--left-arm-border-color', '#bbff45');

        currentStep = 'right';
      }
    });
  });
});
